import {
  closestCenter,
  DndContext,
  DragOverlay,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import { rectSortingStrategy, SortableContext } from "@dnd-kit/sortable";
import Item from "./Item";
import SortableItem from "./SortableItem";

const Thumbnails = ({
  photoOrder,
  images,
  onDeleteImage,
  activeItem,
  onDragStart,
  onDragEnd,
  onDragCancel,
}) => {
  // for input methods detection
  const sensors = useSensors(useSensor(PointerSensor), useSensor(TouchSensor));

  return (
    <>
      <p className={`${images.length > 0 ? "block" : "hidden"}`}>
        ドラッグ&ドロップで画像の入れ替えができます
      </p>
      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={onDragStart}
        onDragEnd={onDragEnd}
        onDragCancel={onDragCancel}
      >
        <SortableContext items={images} strategy={rectSortingStrategy}>
          <div
            className="
              mx-auto
              my-4
              mb-12
              grid
              w-full
              max-w-[800px]
              grid-cols-2
              gap-4
              sm:grid-cols-4
            "
          >
            {images.map((item, index) => (
              <SortableItem
                items={images}
                key={item.id}
                index={photoOrder[index]}
                item={item}
                photoOrder={photoOrder}
                onDeleteImage={onDeleteImage}
              />
            ))}
          </div>
        </SortableContext>
        <DragOverlay adjustScale style={{ transformOrigin: "0 0 " }}>
          {activeItem ? <Item item={activeItem} isDragging /> : null}
        </DragOverlay>
      </DndContext>
    </>
  );
};

export default Thumbnails;
